import { render, staticRenderFns } from "./ConnectReact.vue?vue&type=template&id=06c76f33&scoped=true&"
import script from "./ConnectReact.vue?vue&type=script&lang=js&"
export * from "./ConnectReact.vue?vue&type=script&lang=js&"
import style0 from "./ConnectReact.vue?vue&type=style&index=0&id=06c76f33&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c76f33",
  null
  
)

export default component.exports